export default {
  projectNameById(state) {
    const dict = {}
    for (const entity of state.entities) {
      dict[entity.entity_id] = entity.name
    }
    return dict
  },
}
